import {createApp} from 'vue'
import GridPattern from './GridPattern'

const el = '.be-component--grid-pattern'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((GridPatternDOM)=>{
            const props = {
                topGrid: GridPatternDOM.dataset.topGrid === 'true' ? true : false,
                bottomGrid: GridPatternDOM.dataset.bottomGrid === 'true' ? true : false,
                colortheme: GridPatternDOM.dataset.colortheme ? GridPatternDOM.dataset.colortheme : null
            }
      
            const component = createApp(GridPattern, props).use(Store)
            component.mount(GridPatternDOM)
        })
    }
}